import { api, authApi, getUserId } from "api/base";

const login = async (loginEmail, password) =>
  api.post("/adminLogin", {
    loginEmail,
    password,
  });

const me = async () => authApi.get(`/adminUsers/` + getUserId());

export { login, me };
